class virtualPlaying {
  constructor() {
    this.onDemandData = {};
    this.playMode = "normal";
    this.overlayRecoveryInProgress = false;

    // Reset no-camera mode on each fresh page load (refresh/new tab).
    localStorage.setItem("noCameraMode", "true");

    setInterval(() => { this.checkIsPlaying(); }, 1000);
  }

  virtualCallback = (streamData) => {
    var callback = Object.values(streamData)[0];

    if (callback[0] == "setDemoVideoStage") {
      if (callback[1] === true || callback[1] === 1 || callback[1] === "1") {
        this.isDemoVideoStage = true;
      } else {
        this.isDemoVideoStage = false;
      }
      console.log("isDemoVideoStage virtual playing .js", this.isDemoVideoStage);
    }

    if (callback[0] == "closeOnDemand") {
      this.stop();
      if (window.stopAudio) window.stopAudio();
      document.querySelector("#player_ondemand").innerHTML = "";
      document.querySelector("#player_ondemand").classList.remove("small_video_playing");
      document.querySelector("#player_ondemand").classList.remove("center_video_playing");
      document.querySelector("#player_ondemand").classList.remove("no_camera_half_video");
      if (document.querySelector("iframe#launcher")) { document.querySelector("iframe#launcher").style.display = 'block'; }
      localStorage.setItem("demo_video_num", "");
      if (window.refreshAllData) { window.refreshAllData(); }
      document.body.classList.remove("videoplay-playing");
    }

    if (callback[0] == "minimize") {
      document.querySelector("#player_ondemand").classList.add("small_video_playing");

      var element = document.querySelector("#player_ondemand video");
      element.muted = true;
      element.loop = true;
      element.autoplay = true;
      element.volume = "0";
    }

    if (callback[0] == "playVideo") {
      this.play();
    }
    if (callback[0] == "pauseVideo") {
      this.pause();
    }
    if (callback[0] == "muteVideo") {
      this.muteVideo();
    }
    if (callback[0] == "unmuteVideo") {
      this.unmuteVideo();
    }
    if (callback[0] == "playVideoMutedLoop") {
      const video = document.querySelector("#player_ondemand video");
      if (video) {
        video.muted = true;
        video.volume = 0;
        video.loop = true;
        video.currentTime = 0;
        video.play().catch(() => { });
      }
    }

    if (callback[0] == "playVideoFromStartWithAudio") {
      const video = document.querySelector("#player_ondemand video");
      if (video) {
        video.loop = false;
        video.currentTime = 0;
        video.muted = false;
        video.volume = 1;
      }
      this.play();
    }
    if (callback[0] == "stopVideo") {
      this.stop();
      if (window.stopAudio) window.stopAudio();
      document.querySelector("#player_ondemand").innerHTML = "";
      document.querySelector("#player_ondemand").classList.remove("small_video_playing");
      document.querySelector("#player_ondemand").classList.remove("center_video_playing");
      document.querySelector("#player_ondemand").classList.remove("no_camera_half_video");
      localStorage.setItem("demo_video_num", "");
      document.body.classList.remove("videoplay-playing");
      if (window.recalibrateCameraPreview) {
        window.recalibrateCameraPreview();
      }
    }

    if (callback[0] == "setNoCameraMode") {
      if (callback[1] === true || callback[1] === 1 || callback[1] === "1") {
        localStorage.setItem("noCameraMode", "true"); // 
      } else {
        console.log("Keeping noCameraMode true for now to allow AR testing with camera path (virtual-playing.js)")
        localStorage.setItem("noCameraMode", "false");
        // localStorage.setItem("noCameraMode", "true"); // Always keeping noCameraMode true
      }
    }

    if (callback[0] == "hide") {
      document.querySelector("#player_ondemand").classList.add("hide");
      var element = document.querySelector("#player_ondemand video");
      element.muted = true;
      element.volume = 0;
      this.stop();
      if (window.stopAudio) window.stopAudio();
      document.body.classList.remove("videoplay-playing");
    }

    if (callback[0] == "seekVideo") {
      this.seek(callback[1]);
    }

    if (callback[0] == "pauseTimeDemo") {
      this.pause();
      this.timePauseDemo = callback[1];
    }

    if (callback[0] == "setNoCameraHalfVideo") {
      const container = document.querySelector("#player_ondemand");
      const noCameraMode = localStorage.getItem("noCameraMode") === "true";
      if (!container) return;
      if (callback[1] === true || callback[1] === 1 || callback[1] === "1") {
        const noCameraHalfVideo = container.classList.contains("no_camera_half_video");
        container.classList.add("no_camera_half_video");
        console.log("USER_DECLINES_CAMERA")
        if (window.AnalyticsService?.trackStep) {
          console.log("[TRACKING_STEP] USER_DECLINES_CAMERA")
          try {
            const existingData = JSON.parse(localStorage.getItem("assessmentData")) || {};
            const updatedData = {
              ...existingData,
              userDeclinesCamera: true,
              session_last_update: new Date().toISOString(),
            };
            localStorage.setItem("assessmentData", JSON.stringify(updatedData));
            window.AnalyticsService.trackStep(updatedData);
          } catch (err) {
            console.error("Analytics camera decline error:", err);
          }

          if (window.mayraCode && window.mayraCode.setIsVisible) {
            window.mayraCode.setIsVisible(true);
          }

          if (!noCameraHalfVideo && noCameraMode && window.MyraInteraction.onScreenEnter) {
            const step = localStorage.getItem("runStep") === "2" ? "movement_test_2" : "movement_test_1";
            const wasChatOpen =
              typeof window.MyraInteraction.isChatOpen === "function" &&
              window.MyraInteraction.isChatOpen();

            const wasVoiceOpen =
              typeof window.MyraInteraction.isVoiceOpen === "function" &&
              window.MyraInteraction.isVoiceOpen();

            console.log("wasChatOpen  wasVoiceOpen", wasChatOpen, wasVoiceOpen);
            window.MyraInteraction.onScreenEnter(step);

            // Keep chat/voice panel open if it was open before
            if (wasChatOpen && typeof window.MyraInteraction.openChat === "function" && step !== "movement_test_2") {
              window.MyraInteraction.openChat();
            }
            if (wasVoiceOpen && typeof window.MyraInteraction.openVoice === "function" && step !== "movement_test_2") {
              window.MyraInteraction.openVoice();
            }
          }
        }
      } else {
        container.classList.remove("no_camera_half_video");
      }
    }
  };

  startOnDemandStream = (streamData) => {
    document.body.classList = [];
    if (document.querySelector("iframe#launcher")) { document.querySelector("iframe#launcher").style.display = 'none'; }
    const isV2 = localStorage.getItem("isV2") == "true" && localStorage.getItem("cameFromGsaV2") == "true";
    this.isDemoVideoStage = isV2 ? false : true;
    const currentAssessmentRoot = document.getElementById("onDemandPlayingRoot");
    if (currentAssessmentRoot) currentAssessmentRoot.style.display = "block";

    let newStreamData = window.checkIsSelf();
    streamData = !newStreamData || newStreamData == 'no' ? streamData : newStreamData;

    this.onDemandData = JSON.parse(streamData);
    if (this.onDemandData && this.onDemandData["activities"]) {
      var img = new Image();
      for (var i = 0; i < this.onDemandData["activities"].length; i++) {
        img.src = this.onDemandData["activities"][i]["image"];
      }
    }
    this.lastDemoPaused = localStorage.getItem("demo_video_num");
    if (this.lastDemoPaused && this.timePauseDemo > 0) {
      setTimeout(() => {
        var portrait = localStorage.getItem("flutter.isPortraitAllowed") != null ? localStorage.getItem("flutter.isPortraitAllowed") : false;
        this.startVideoPlay(this.lastDemoPaused, portrait);
        document.querySelector("#player_ondemand video").currentTime = this.timePauseDemo;
        window.currentActiv(this.lastDemoPaused);
      }, 100);
    } else {
      var video = localStorage.getItem("flutter.firstUndone") != null ? localStorage.getItem("flutter.firstUndone") : 0;
      var portrait = localStorage.getItem("flutter.isPortraitAllowed") != null ? localStorage.getItem("flutter.isPortraitAllowed") : false;
      this.startVideoPlay(video, portrait);
    }
  };

  setOnDemandStream = (streamData) => {
    this.onDemandData = JSON.parse(streamData);
  };

  preloadDemandStream = (streamData) => {
    this.onDemandData = JSON.parse(streamData);

    let audioList = [];
    const acts = this.onDemandData?.activities ?? [];
    for (let i = 0; i < acts.length; i++) {
      if (acts[i].demo_video) {
        audioList.push(acts[i].demo_video.replace('.mp4', '.mp3?v=1.0').replace('virtual_demovideo/', 'virtual_demomp3/'));
      }
    }
    audioList = [...new Set(audioList)];

    const _unlockOnce = () => {
      try {
        if (window.preloadMultipleAudios) { window.preloadMultipleAudios(audioList); }
      } catch { }
    };
    window.addEventListener("mousedown", _unlockOnce, { capture: true, once: true });
    window.addEventListener("touchstart", _unlockOnce, { capture: true, once: true });
  };

  startVideoPlay = (indexA, isPortraitAllowed) => {
    const noCameraMode = localStorage.getItem("noCameraMode") === "true";
    console.log("noCameraMode virtual playing .js", noCameraMode);
    if (this.onDemandData && this.onDemandData["activities"] && this.onDemandData["activities"][indexA] && (this.onDemandData["activities"][indexA]['show_demo'] == 1 || noCameraMode)) {
      console.log('video started palying ');
      var kIsWeb = localStorage.getItem("flutter.kIsWeb") != null ? localStorage.getItem("flutter.kIsWeb") : false;
      var videoToPlay = this.onDemandData["activities"][indexA]["demo_video"];

      if ((isPortraitAllowed == '"true"' || isPortraitAllowed == true) && kIsWeb == '"false"' && this.onDemandData["activities"][indexA]["portrait_video"] != null) {
        console.log('#Play portrait video');
        videoToPlay = this.onDemandData["activities"][indexA]["portrait_video"];
      }
      // set onDemandPlayingRoot to block so video shows
      if (document.getElementById("OnDemandPlayingRoot")) {
        document.getElementById("OnDemandPlayingRoot").style.display = "block";
      }

	  let posterImage = this.onDemandData["activities"][indexA]["image"];

      let isNoCamera = localStorage.getItem("noCameraMode") == 'true';
      const activityName = this.onDemandData["activities"][indexA]["display_name"]?.trim().toLowerCase();
      let noCameraVideo = videoToPlay
        .replace('/virtual_demovideo/', '/virtual_demovideo_nc/')
        .replace('/virtual_video/', '/virtual_demovideo_nc/')
        .replace('.mp4', '-NC.mp4')
        .replace('Demo%20-%20Seated%20Single%20Knee%20To%20Chest-NC.mp4', 'SeatedSingleKneeToChestv1-NC.mp4')
        .replace('Demo - Seated Single Knee To Chest-NC.mp4', 'SeatedSingleKneeToChestv1-NC.mp4');
      console.log("activityName virtual playing .js", activityName);
      const noCameraActivities = [
        "standing lumbar extension",
        "seated trunk rotation",
        "side to side bend",
        "toe touch",
        "single knee to chest",
        "seated single knee to chest",
        "standing hip flexor stretch",
        "seated glute stretch",
        "seated hip hinge",
        "seated hip abduction",
        "seated isometric knee extension",
        "standing itb stretch - side bend left arm",
        "squat",
        "lateral lunge",
        "bird dog hold",
        "bird dog",
        "clam shells",
        "plank on elbows",
        "plank arms extended",
        "side plank on elbow",
        "child pose",
        "standing quadriceps stretch with chair",
        "standing calf stretch against the wall",
        "v sit hip adductor hamstring stretch",
        "supine single knee to chest",
        "curl ups",
        "supine hamstring stretch",
        "prone press up",
        "plank against the wall",
        "side plank against the wall",
        "cat cow pose",
        "supine double knee to chest",
        "dead bug with heel taps",
        "supine double knee with knees bent",
        "supine hamstring stretch with knees bent",
        "plank on elbows on knee",
        "plank arms extended on knees",
        "side plank on elbow on knees",
        "seated crunch",
        "seated toe tap",
        "seated bicycle crunch",
        "seated lumbar flexion",
        "seated dead bug",
        "seated bird dog",
        "sit to stand",
        "seated squat",
        "wall squat",
        "supine figure 4 stretch",
        "standing hip extension",
        "standing passive hip flexion with chair",
        "standing hip internal rotation",
        "standing hip external rotation",
        "quadratus lumborum stretch",
        "seated spine rotation stretch",
        "seated low to high torso rotation",
        "seated trunk side bending",
        "seated lateral muscles stretch",
        "seated hamstring stretch",
        "seated hip internal rotation",
        "alternating lunges",
        "crossover lunge",
        "warrior",
        "mountain climbers",
        "lateral single leg lunge jumps",
        "standing itb stretch - toe touch",
        "downward dog",
        "standing hip extension with chair",
        "supine hamstring stretch with strap",
        "wall squat hold with ball",
        "seated isometric hip abduction",
        "seated hip adduction isometrics with ball",
        "standing hip flexion with anchored resistance and chair support",
        "wall squat with heel raises",
        "squat to heel raise",
        "side stepping with resistance at thighs",
        "standing hip abduction with anchored resistance",
        "standing hip abduction",
        "sidelying hip abduction",
        "standing itb stretch - side bend",
        "side plank with clam",
        "goblet squat with kettlebell",
        "seated hip external and internal rotation right",
        "seated hip external and internal rotation",
        "standing single leg circles with chair",
        "inchworm",
        "quadruped fire hydrant",
        "clam shell with band",
        "sidelying hip abduction with resistance at thighs",
        "hooklying single leg bent knee fallouts with resistance",
        "beginner leg single prone raise",
        "supine bridge",
        "supine bridge with mini swiss ball between knees",
        "quadruped bent leg hip extension",
        "supine bridge with leg extension",
        "single leg bridge",
        "prone alternating arm and leg lifts",
        "supine single knee with knees bent",
        "supine knee flexion",
        "quadruped leg lifts",
        "superman",
        "active straight leg raise with quad set",
        "supine knee extension strengthening",
        "dead bug",
        "new exercise"
      ];
      const isAllowedExercise =
        !!activityName && noCameraActivities.includes(activityName);
      if (isNoCamera && noCameraVideo && isAllowedExercise && !this.isDemoVideoStage) {
        videoToPlay = noCameraVideo;
        posterImage = noCameraVideo.replace('.mp4', '.jpg');
      }

      console.log("videoToPlay virtual playing .js", videoToPlay);

      document.querySelector("#player_ondemand").innerHTML = `
    <video autoplay playsinline poster="`+ posterImage + `"><source src="` + videoToPlay + `" type="video/mp4"></video>
    `;
      this.attachVideoListeners(document.querySelector("#player_ondemand video"));
      this.play();
      document.querySelector("#player_ondemand video").ontimeupdate = this.updateVideoData;
      document.querySelector("#player_ondemand video").onloadedmetadata = this.updateVideoData;
    }
    localStorage.setItem("demo_video_num", indexA);

    window.virtualDemoPlay = this;
  };

  loadMp3WithRetry = async (url, offset = 0, retries = 3, delay = 500) => {
    const audioPlayer = window.audioPlayer;
    if (!audioPlayer || !audioPlayer.unlocked) {
      if (window.initFromUserGesture) {
        window.initFromUserGesture();
        await new Promise(r => setTimeout(r, 200));
      } else {
        throw new Error("WebAudio not unlocked");
      }
    }

    if (audioPlayer.ensureCtxRunning) {
      await audioPlayer.ensureCtxRunning();
    }

    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        const result = await audioPlayer.playAudioAt(url, offset);
        if (result && result.success) return result;

        if (attempt < retries) {
          await new Promise(r => setTimeout(r, delay * attempt));
        }
      } catch (err) {
        if (attempt < retries) {
          const backoffDelay = delay * Math.pow(1.5, attempt - 1);
          await new Promise(r => setTimeout(r, backoffDelay));
        }
      }
    }

    throw new Error("MP3 failed after retries");
  };

  startRepVideoPlay = (video) => {
    document.querySelector("#player_ondemand").innerHTML = '<video><source src="' + video + '" type="video/mp4"></video>';
    this.play();
    document.querySelector("#player_ondemand video").ontimeupdate = this.updateVideoData;
    document.querySelector("#player_ondemand video").onloadedmetadata = this.updateVideoData;
  };

  clearDemoVideoNum = () => {
    localStorage.setItem("demo_video_num", "");
  };

  play = async () => {
    const video = document.querySelector("#player_ondemand video");
    if (!video) return;

    const noCameraMode = localStorage.getItem("noCameraMode") === "true";
    if (noCameraMode && !this.isDemoVideoStage ) {
      video.muted = true;
      video.volume = 0;

      // Kill any leftover overlay audio (e.g. the demo's narration mp3 on Safari).
      // Otherwise checkIsPlaying keeps recovering it against this muted no-camera
      // video and the demo audio leaks through the intro/countdown.
      this.playMode = "normal";
      if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
        window.audioPlayer.stopAudio(this.overlayAudioUrl);
        this.overlayAudioActive = false;
      }

      await video.play().catch(() => { });
	  document.body.classList.add("videoplay-playing");
	  document.querySelector("#player_ondemand").classList.remove("hide");
      return;
    }

    document.body.classList.add("videoplay-playing");
    document.querySelector("#player_ondemand").classList.remove("hide");

    this.playMode = "normal";
    this.overlayAudioActive = false;

    if (this.overlayAudioUrl && window.audioPlayer) {
      window.audioPlayer.stopAudio(this.overlayAudioUrl);
      this.overlayAudioUrl = null;
    }

    let normalPlaySucceeded = false;

    try {
      video.muted = true;
      video.volume = 0;
      await video.play();

      video.muted = false;
      video.volume = 1;
      await video.play();

      this.playMode = "normal";
      normalPlaySucceeded = true;

      // ===== FIX START =====

      if (video.muted || video.volume === 0) {
        console.warn('⚠️ Safari silently suppressed audio');
        video.muted = true;
        video.volume = 0;
        this.playMode = "overlay";
        normalPlaySucceeded = false;
      }

      if (normalPlaySucceeded) {
        await new Promise(r => setTimeout(r, 300));
        if (video.muted || video.volume === 0) {
          console.warn('⚠️ Safari delayed audio suppression detected');
          video.muted = true;
          video.volume = 0;
          this.playMode = "overlay";
          normalPlaySucceeded = false;
        }
      }

      // ===== FIX END =====

      if (!video.muted) {
        this.playMode = "normal";
        normalPlaySucceeded = true;
      }

    } catch (e) {
      video.muted = true;
      video.volume = 0;
      this.playMode = "overlay";
      this.trackVideoEvent("video_playback_failed", {
        error_code: "PLAY_PROMISE_REJECTED",
        error_message: e?.message || String(e),
      });
    }

    if (normalPlaySucceeded) {
      // Final micro-check (critical for Safari)
      await new Promise(r => setTimeout(r, 300));

      if (video.muted || video.volume === 0) {
        console.warn("⚠️ Safari post-check mute detected → forcing overlay");
        normalPlaySucceeded = false;
        this.playMode = "overlay";
      } else {
        if (window.getLastPickedSpeaker?.()) {
          try {
            video.setSinkId(window.getLastPickedSpeaker()["deviceId"]);
          } catch (err) {
            console.warn("setSinkId failed", err);
          }
        }
        return;
      }
    }

    if (this.playMode === "overlay") {
      try {
        video.pause();

        const offset = video.currentTime;
        const videoSrc = video.querySelector('source')?.src || video.src || '';

        let mp3Url = videoSrc
          .replace('.mp4', '.mp3?v=1.0')
          .replace('.MP4', '.mp3?v=1.0')
          .replace('virtual_demovideo/', 'virtual_demomp3/');

        const result = await this.loadMp3WithRetry(mp3Url, offset, 3, 500);
        if (!result || !result.success) {
          await video.play().catch(() => { });
          return;
        }

        this.overlayRecoveryInProgress = false;
        this.overlayAudioActive = true;
        this.overlayAudioUrl = mp3Url;

        const ctx = window.audioPlayer.ctx;
        const startAt = result.scheduledTime;

        video.currentTime = offset;

        let delayMs = (startAt - ctx.currentTime) * 1000;
        if (delayMs < 0) delayMs = 0;

        await new Promise(resolve => setTimeout(resolve, delayMs));
        await video.play();

      } catch (err) {
        this.overlayAudioActive = false;
        this.overlayAudioUrl = null;
        this.trackVideoEvent("video_playback_failed", {
          error_code: "OVERLAY_PLAY_FAILED",
          error_message: err?.message || String(err),
        });
        await video.play().catch(() => { });
      }
    }

    if (window.getLastPickedSpeaker?.()) {
      try {
        video.setSinkId(window.getLastPickedSpeaker()["deviceId"]);
      } catch (err) { }
    }
  };

  pause = () => {
    const video = document.querySelector("#player_ondemand video");
    if (!video) return;
    video.pause();

    if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
      window.audioPlayer.stopAudio(this.overlayAudioUrl);
      this.overlayAudioActive = false;
    }
  };

  muteVideo = () => {
    const video = document.querySelector("#player_ondemand video");
    if (!video) return;
    video.muted = true;
    video.volume = 0;

    if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
      window.audioPlayer.stopAudio(this.overlayAudioUrl);
      this.overlayAudioActive = false;
    }
  };

  unmuteVideo = async () => {
    const video = document.querySelector("#player_ondemand video");
    if (!video) return;

    if (this.playMode === "overlay") {
      if (this.overlayAudioActive || !window.audioPlayer) return;
      try {
        video.pause();
        const offset = video.currentTime;

        let mp3Url = this.overlayAudioUrl;
        if (!mp3Url) {
          const videoSrc = video.querySelector('source')?.src || video.src || '';
          mp3Url = videoSrc
            .replace('.mp4', '.mp3?v=1.0')
            .replace('.MP4', '.mp3?v=1.0')
            .replace('virtual_demovideo/', 'virtual_demomp3/');
        }

        const result = await this.loadMp3WithRetry(mp3Url, offset, 3, 500);
        if (!result || !result.success) {
          await video.play().catch(() => { });
          return;
        }

        this.overlayAudioActive = true;
        this.overlayAudioUrl = mp3Url;

        const ctx = window.audioPlayer.ctx;
        video.currentTime = offset;

        let delayMs = (result.scheduledTime - ctx.currentTime) * 1000;
        if (delayMs < 0) delayMs = 0;

        await new Promise(resolve => setTimeout(resolve, delayMs));
        await video.play();
      } catch (err) {
        this.overlayAudioActive = false;
        await video.play().catch(() => { });
      }
      return;
    }

    video.muted = false;
    video.volume = 1;
  };

  stop = () => {
    document.body.classList.remove("videoplay-playing");

    const video = document.querySelector("#player_ondemand video");
    if (!video) return;
    video.pause();
    video.currentTime = 0;

    if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
      window.audioPlayer.stopAudio(this.overlayAudioUrl);
      this.overlayAudioActive = false;
    }
  };

  seek = async (seek_val) => {
    const video = document.querySelector("#player_ondemand video");
    if (!video) return;

    video.pause();
    video.currentTime = seek_val;

    if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
      window.audioPlayer.stopAudio(this.overlayAudioUrl);

      const result = await this.loadMp3WithRetry(this.overlayAudioUrl, seek_val, 2, 400);
      if (!result?.success) return;

      const ctx = window.audioPlayer.ctx;
      const startAt = result.scheduledTime;

      let delayMs = (startAt - ctx.currentTime) * 1000;
      if (delayMs < 0) delayMs = 0;

      await new Promise(resolve => setTimeout(resolve, delayMs));
    }

    await video.play();
  };

  getContextType = () => {
    const runStep = localStorage.getItem("runStep");
    if (runStep === "1") return "movement_test_1";
    if (runStep === "2") return "movement_test_2";
    return "exercise";
  };

  trackVideoEvent = (eventName, extra = {}) => {
    try {
      if (!window.trackFlutterEvent) return;
      const video = document.querySelector("#player_ondemand video");
      const videoUrl = video?.querySelector("source")?.src || video?.src || "";
      window.trackFlutterEvent({
        event_name: eventName,
        context_type: this.getContextType(),
        video_url: videoUrl,
        //...extra,
      });
    } catch (err) {
      console.error("trackVideoEvent error:", err);
    }
  };

  attachVideoListeners = (videoEl) => {
    if (!videoEl) return;

    videoEl.addEventListener("playing", () => {
      this.trackVideoEvent("video_playback_started");
    });

    videoEl.addEventListener("error", () => {
      const mediaError = videoEl.error;
      this.trackVideoEvent("video_playback_failed", {
        error_code: mediaError?.code ?? null,
        error_message: mediaError?.message ?? null,
      });
    });

    const sourceEl = videoEl.querySelector("source");
    if (sourceEl) {
      sourceEl.addEventListener("error", () => {
        this.trackVideoEvent("video_playback_failed", {
          error_code: "SOURCE_LOAD_FAILED",
          error_message: "Failed to load <source> element",
        });
      });
    }
  };

  updateVideoData = () => {
    if (document.querySelector("#player_ondemand video") && window.flutter_OnDemand) {
      window.flutter_OnDemand(
        JSON.stringify({
          method: "videoProgress",
          timeElapsed: document.querySelector("#player_ondemand video").currentTime,
          duration: document.querySelector("#player_ondemand video").duration,
        })
      );
    }
  };

  setFullScreen = () => {
    document.querySelector("#player_ondemand").classList.remove("small_video_playing");
    document.querySelector("#player_ondemand").classList.remove("hide");
    var element = document.querySelector("#player_ondemand video");
    element.muted = false;
    element.loop = false;
    element.autoplay = true;
  };

  checkIsPlaying = async () => {
    const video = document.querySelector("#player_ondemand video");

    if (!video) {
      if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
        window.audioPlayer.stopAudio(this.overlayAudioUrl);
        this.overlayAudioActive = false;
      }
      return;
    }

    if (video.paused) {
      if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
        window.audioPlayer.stopAudio(this.overlayAudioUrl);
        this.overlayAudioActive = false;
      }
      return;
    }

    if (!video.muted) {
      if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
        window.audioPlayer.stopAudio(this.overlayAudioUrl);
        this.overlayAudioActive = false;
      }
      return;
    }

    if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
      const isPlaying = window.audioPlayer.isAudioPlaying(this.overlayAudioUrl);

      if (!isPlaying && !this.overlayRecoveryInProgress && video.muted) {
        this.overlayRecoveryInProgress = true;

        setTimeout(async () => {
          try {
            const offset = video.currentTime;
            await this.loadMp3WithRetry(this.overlayAudioUrl, offset, 2, 300);
          } catch { }
        }, 300);

        setTimeout(() => {
          this.overlayRecoveryInProgress = false;
        }, 1500);
      }
    }
  };

  hideSupportHelp = () => {
    if (document.querySelector("iframe#launcher")) { document.querySelector("iframe#launcher").style.display = 'none'; }
  }

  showSupportHelp = () => {
    if (document.querySelector("iframe#launcher")) { document.querySelector("iframe#launcher").style.display = 'block'; }
  }

  listenNative = () => {
    window.hideSupportHelp = this.hideSupportHelp;
    window.showSupportHelp = this.showSupportHelp;

    window.virtualCallback = this.virtualCallback;
    window.startOnDemandStream = this.startOnDemandStream;
    window.setOnDemandStream = this.setOnDemandStream;
    window.setFullScreen = this.setFullScreen;
    window.startVideoPlay = this.startVideoPlay;
    window.startRepVideoPlay = this.startRepVideoPlay;
    window.clearDemoVideoNum = this.clearDemoVideoNum;

    window.preloadDemandStream = this.preloadDemandStream;
  };
}

export default virtualPlaying;